module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.0a45847b.webp";